import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataUu from './phonics/phonics_data_uu';

function PhonicsUu() {
  return <PhonicsAtoZ letterData={letterDataUu} />;
}

export default PhonicsUu;
